import {
  Component, OnInit, NgZone, ChangeDetectorRef, HostBinding,
  ElementRef, Renderer2, ViewChild, OnDestroy
} from '@angular/core';
import { icon, latLng, marker, polyline, tileLayer, layerGroup,
  divIcon, geoJSON, gridLayer, LeafletEvent, LeafletMouseEvent } from 'leaflet';
import 'ih-leaflet-canvaslayer-field/dist/leaflet.canvaslayer.field.js'; // direction animation
// divIcon, geoJSON, gridLayer, LeafletEvent, LeafletMouseEvent, MarkerCluster } from 'leaflet';
import { Title } from '@angular/platform-browser';
import { MapsService, AppSettingsService, SharedService,
  MapsInteractiveService, MetaService } from './../../../services';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import 'leaflet-velocity';

declare var L: any; // Declare leaflet lib and plugin
declare var GeoTIFF;
declare var rastertools;
declare var d3;
declare var chroma;

@Component({
  selector: 'widget-forecast-maps',
  templateUrl: './forecast-maps.component.html',
  styleUrls: ['./forecast-maps.component.scss']
})

export class ForecastMapsComponent implements OnInit, OnDestroy {

  constructor(
    private titleService: Title,
    private _maps: MapsService,
    private _mapsInteractive: MapsInteractiveService,
    private _meta: MetaService,
    private _shared: SharedService,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private _router: Router,
    private route: ActivatedRoute,
    private readonly elementRef: ElementRef,
    private renderer: Renderer2,
  ) { }

  @ViewChild('timelineContainer', {static: false})
  timelineContainer: ElementRef|undefined;
  @ViewChild('controlContainer', {static: false})
  controlContainer: ElementRef|undefined;

  subscribtionDate: Subscription;
  subscribtionDirectionU: Subscription;
  subscribtionDirectionV: Subscription;
  subscribtionTemperature: Subscription;
  subscribtionWindMAX: Subscription;
  subscribtionPrecipitation: Subscription;
  subscribtionCloudy: Subscription;
  subscribtionPMSL: Subscription;
  subscribtionRELHUM: Subscription;
  subscribtionCAPE_CON: Subscription;
  subscribtionFooterHeight: Subscription;
  subscribtionStorm: Subscription;
  subscribtionHydroStorm: Subscription;
  subscribtionCity: Subscription;
  subscribtionTime: Subscription;

  isSmallScreen = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
  isMobileAds = this.breakpointObserver.isMatched('screen and (max-width: 788px)');
  isTabletAds = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');
  isSmallHeader = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');

  contentMinHeight;
  haveStorm;
  haveHydroStorm;
  blurableSVG;
  maxZoom;
  blurableCANVAS;
  // footerHeight;
  canLoadNext = true;
  canLoadInterval = true;

map: L.Map;
public fullscreenOptions: {[key: string]: any} = {
  position: 'topright',
};
zone: NgZone;
world = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Polygon',
        coordinates: [[[-20, 70], [-20, 29], [45, 29], [45, 70], [-20, 70]]]
      }
    }
  ]
};
minZoom = 6;
options = {
  layers: [
    new L.TileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      boundary: this.world,
      detectRetina: true,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Белгидромет',
    })],
  zoom: 6,
  hideSingleBase: true,
  zoomControl: false,
  center: latLng([53.8, 28]),
};
selectedCity;
timeUTC;
bounds;
panInsideBounds;

intervals = [];

TYPES_MAP_selected = 'ICON';
TYPES = {
  DIRECTION: 'DIRECTION',
  TEMPERATURE: 'TEMPERATURE',
  PRECIPITATION: 'PRECIPITATION'
};
listTyped1 = [
  { title: 'ОСАДКИ', type: this.TYPES.PRECIPITATION },
  { title: 'ВЕТЕР', type: this.TYPES.DIRECTION },
  { title: 'ТЕМПЕРАТУРА', type: this.TYPES.TEMPERATURE },
];
typeSelected = null;
typesTemperature = [
  { title: '2 м', value: 'T_2M'},  // T_2M
  { title: '925 гПа', value: '925_T'}, // 925_T
  { title: '850 гПа', value: '850_T'}, // 850_T
  { title: '700 гПа', value: '700_T'}, // 700_T
  { title: '500 гПа', value: '500_T'}  // 500_T
];
typesTemperatureSelected = 'T_2M';

typesDIRECTION = [
  { title: '10 м', value: '10M'},  // RELHUM_2M
  { title: '925 гПа', value: '925'}, // 925_RELHUM
  { title: '850 гПа', value: '850'}, // 850_RELHUM
  { title: '700 гПа', value: '700'}, // 700_RELHUM
  { title: '500 гПа', value: '500'}  // 500_RELHUM
];
typesDIRECTIONSelected = '10M';

currentDate;
currentHalfDay;

loading = false;

////  FORECAST  ////
hideLayersMenu = true;
forecastLayer; // for render tiff
forecastDate = undefined;
forecastTime = undefined;
forecastHourIndex = 0;
forecastLastHiddenIndex = undefined;
forecastTimeline = ['000', '003', '006', '009', '012', '015', '018', '021', '024',
  '027', '030', '033', '036', '039', '042', '045', '048',
  '051', '054', '057', '060', '063', '066', '069', '072',
  '075', '078', '081', '084', '087', '090', '093', '096',
  '099', '102', '105', '108', '111', '114', '117', '120'];
forecastTimelineDays = [];
forecastTimelineHours = [];
intervalsForecastTemperature = [];
forecastGradientTemperature = ['170042', '430089', '1E00B8', '1B0FE3', '1919FF', '0066FF', '0991FD', '11BCFA', '4EE2ED',
  'C6F0FF', '00C45D', '529100', '609A00', '9ABF00', 'EDE615', 'F4AD33', 'E17945', 'DD6E48', 'B54E54'];
forecastIntervalTemperature = [-32, -28, -24, -20, -16, -12, -8, -4, -2, 0, 2, 4, 8, 12, 16, 20, 24, 28, 32];

intervalsForecastPrecipitation = [];
forecastGradientPrecipitation = ['47a2fc', '8EB3FF', '698CFF', '5355FF', '5F2FFF', '7A00E6', '4B0073'];
forecastIntervalPrecipitation = [0, 2.5, 5.0, 7.5, 10.0, 12.5];
forecastIntervalWindMAX = [0, 5, 10, 15, 20, 25, 30, 35];

forecastPlayTimer;
forecastPlaying = false;
scalarWindInterpolateLayer;
canIuseGetForecastDate = true;

data = ['00', '06', '12', '18', '24', '30', '36', '42', '48', '54', '60', '66', '72', '84', '96', '108', '120'];
  minLoadInterval = () => {
    this.canLoadInterval = false;
    setTimeout(() => this.canLoadInterval = true, 950);
  }
onClick(e) {
  e.stopPropagation();
}
onClick2(div) {
  L.DomEvent.disableClickPropagation(div);
}
onMapReady(map: L.Map) {
  this.map = map;

  const southWest = L.latLng(70.2, -22.5);
  const northEast = L.latLng(30.3, 44.4);
  const bounds = L.latLngBounds(southWest, northEast);
  L.control.zoom({
    position: 'topright'
  }).addTo(this.map);
  map.setMaxBounds(bounds);
  this.panInsideBounds = map.panInsideBounds;
}
getBounds = (bounds) => function() {
  this.panInsideBounds(bounds, { animate: false });
}
  isFinited = num => Number.isFinite(num);

getGeoTiffFilename() {
  const type = this.TYPES_MAP_selected;
  const hour = this.forecastTimeline[this.forecastHourIndex];
  if (this.typeSelected === this.TYPES.TEMPERATURE) {
    const level = this.typesTemperatureSelected === 'T_2M' ? 'single-level' : 'pressure-level';
    return `forecast/${this.currentDate}/${this.currentHalfDay}/${hour}/${type.toLowerCase()}-eu_europe_regular-lat-lon_${level}_${this.currentDate}${this.currentHalfDay}_${hour}_${this.typesTemperatureSelected}.tiff`;
  } else if (this.typeSelected === this.TYPES.PRECIPITATION) {
    const level = 'single-level';
    return `forecast/${this.currentDate}/${this.currentHalfDay}/${hour}/${type.toLowerCase()}-eu_europe_regular-lat-lon_${level}_${this.currentDate}${this.currentHalfDay}_${hour}_TOT_PREC.tiff`;
  }
}


moveScroll(i) {
    const containerWidth = this.timelineContainer.nativeElement.offsetWidth;
    this.timelineContainer.nativeElement.scrollLeft = i * 34 - containerWidth / 2 + 17;
}

setForecastHour(i) {
  if (this.forecastLastHiddenIndex < i) {
    this.forecastHourIndex = i;
    this.moveScroll(i);
    this.getForecast();
  } else if (this.forecastLastHiddenIndex + 1 == i + 1) {
    this.forecastHourIndex = i + 1;
    this.moveScroll(i);
    this.getForecast();
  } else if (this.forecastLastHiddenIndex + 1 <= this.forecastTimelineHours.length - 1) {
    this.forecastHourIndex = this.forecastLastHiddenIndex + 1;
    this.moveScroll(i);
    this.getForecast();
  }
}
getTime(num) {
  num = (Number(num) + Number(this.currentHalfDay)) % 24;
  num = `${num}`.length === 1 ? `0${num}` : num;
  return `${num}`;
}
getTimezone() {
  return this.timeUTC ? '+0' : (this.selectedCity.timezone < 0 ? '' + this.selectedCity.timezone : '+' + this.selectedCity.timezone);
}
isNotOverHours(t) {
  return new Date(t).getTime() >= new Date().getTime();
}
isNotOverDay(t) {
  const year = new Date(t).getUTCFullYear() >= new Date().getUTCFullYear();
  const month = new Date(t).getUTCMonth() >= new Date().getUTCMonth();
  const day = new Date(t).getUTCDate() >= new Date().getUTCDate();
  const shiftHours = this.timeUTC ? 0 : this.selectedCity.timezone;
  // return year && month && day;
  if (new Date(t).getUTCFullYear() > new Date().getUTCFullYear()) { return true; } else if (new Date(t).getUTCMonth() > new Date().getUTCMonth()) { return true; } else if (new Date(t).getUTCDate() > new Date().getUTCDate()) { return true; } else { return year && month && day && (new Date().getUTCHours() + shiftHours * 2 < 24); }
}
getDays() {
  const arrDays = [];
  const arrHours = [];
  let forecastLastHiddenIndex;
  const date = new Date([
    this.forecastDate.slice(0, 4),
    this.forecastDate.slice(4, 6),
    this.forecastDate.slice(6, 8)
  ].join('-') + 'T00:00:00.000+00:00'); // UTC(+0) changed to .000+00:00
  const date2 = date && new Date(date).valueOf(); // date 00:00:00
  this.forecastTimeline.forEach((v, i) => {
    const tmp = new Date(date2).setUTCHours(new Date(date2).getUTCHours() +
      Number(v) + Number(this.currentHalfDay) );
    arrHours.push(tmp);
    if (new Date(arrDays[arrDays.length - 1]).getUTCDate() !== new Date(tmp).getUTCDate()) {
      arrDays.push(tmp);
    }
    if (!this.isNotOverHours(tmp)) {
      forecastLastHiddenIndex = i;
    }
  });
  this.forecastTimelineDays = arrDays;
  this.forecastTimelineHours = arrHours;
  this.forecastLastHiddenIndex = forecastLastHiddenIndex;
  this.forecastHourIndex =
    this.forecastHourIndex > this.forecastLastHiddenIndex
      ? this.forecastHourIndex : this.forecastLastHiddenIndex + 1;
}
shiftTimelineDay() {
  const shiftTimezone = Math.floor( (!this.timeUTC ? Number(this.selectedCity.timezone) : 0) / 3) * 34; // width of timeline hour
  return (this.currentHalfDay == '12' ? ' - 136px' : '') + ` - ${shiftTimezone}px`;
}
getDay(ms) {
  const week = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];
  const dayOfWeek = new Date(ms).getUTCDay();
  return `${week[dayOfWeek - 1] || 'Воскресенье'}`; // I DON'T KNOW WHY
}
// temperature
getForecastGradientTemperature() {
  const arr = [];
  const steps = 4;
  this.forecastGradientTemperature = ['170042', '430089', '1E00B8', '1B0FE3', '1919FF', '0066FF', '0991FD', '11BCFA', '4EE2ED',
    'C6F0FF', '00C45D', '529100', '609A00', '9ABF00', 'EDE615', 'F4AD33', 'E17945', 'DD6E48', 'B54E54'];
  this.forecastGradientTemperature.forEach((v, i) => {
    if (this.forecastGradientTemperature[i + 1]) {
      const r1 = parseInt(v.substr(0, 2), 16);
      const g1 = parseInt(v.substr(2, 2), 16);
      const b1 = parseInt(v.substr(4, 2), 16);
      const r2 = parseInt(this.forecastGradientTemperature[i + 1].substr(0, 2), 16);
      const g2 = parseInt(this.forecastGradientTemperature[i + 1].substr(2, 2), 16);
      const b2 = parseInt(this.forecastGradientTemperature[i + 1].substr(4, 2), 16);
      const rStep = (r2 - r1) / steps;
      const gStep = (g2 - g1) / steps;
      const bStep = (b2 - b1) / steps;
      for (let i2 = 0; i2 < steps; i2++) {
        let r = Number((r1 + rStep * i2).toFixed(0)).toString(16);
        r = r.length === 1 ? '0' + r : r;
        let g = Number((g1 + gStep * i2).toFixed(0)).toString(16);
        g = g.length === 1 ? '0' + g : g;
        let b = Number((b1 + bStep * i2).toFixed(0)).toString(16);
        b = b.length === 1 ? '0' + b : b;
        arr.push(`#${r}${g}${b}`);
      }
    }
  });
  arr.push('#880015');
  arr.unshift('#a349a4');
  this.forecastGradientTemperature = arr;
}
getForecastColor = (type, d) => {
  type = type[0].toUpperCase() + type.slice(1);
  const check = i => (d > this.intervalsForecastTemperature[i])
    ? this.forecastGradientTemperature[i]
    : (i > 0 ? check(i - 1) : this.forecastGradientTemperature[0]);
  return check(74);
}

getForecastGradientPrecipitation() {
  const arr = [];
  const steps = 8;
  this.forecastGradientPrecipitation = ['47a2fc', '8EB3FF', '698CFF', '5355FF', '5F2FFF', '7A00E6', '4B0073'];
  this.forecastGradientPrecipitation.forEach((v, i) => {
    if (this.forecastGradientPrecipitation[i + 1]) {
      const r1 = parseInt(v.substr(0, 2), 16);
      const g1 = parseInt(v.substr(2, 2), 16);
      const b1 = parseInt(v.substr(4, 2), 16);
      const r2 = parseInt(this.forecastGradientPrecipitation[i + 1].substr(0, 2), 16);
      const g2 = parseInt(this.forecastGradientPrecipitation[i + 1].substr(2, 2), 16);
      const b2 = parseInt(this.forecastGradientPrecipitation[i + 1].substr(4, 2), 16);
      const rStep = (r2 - r1) / steps;
      const gStep = (g2 - g1) / steps;
      const bStep = (b2 - b1) / steps;
      for (let i2 = 0; i2 < steps; i2++) {
        let r = Number((r1 + rStep * i2).toFixed(0)).toString(16);
        r = r.length === 1 ? '0' + r : r;
        let g = Number((g1 + gStep * i2).toFixed(0)).toString(16);
        g = g.length === 1 ? '0' + g : g;
        let b = Number((b1 + bStep * i2).toFixed(0)).toString(16);
        b = b.length === 1 ? '0' + b : b;
        arr.push(`#${r}${g}${b}`);
      }
    }
  });
  arr.push('#640032');
  this.forecastGradientPrecipitation = arr;
}
getForecastColorPrecipitation = (type, d) => {
  type = type[0].toUpperCase() + type.slice(1);
  const check = i => (d > this.intervalsForecastPrecipitation[i])
    ? this.forecastGradientPrecipitation[i]
    : (i > 0 ? check(i - 1) : this.forecastGradientPrecipitation[0]);
  return check(50);
}

getForecastInterval() {
  if (this.typeSelected === this.TYPES.TEMPERATURE) {
    return this.forecastIntervalTemperature;
  } else if (this.typeSelected === this.TYPES.PRECIPITATION) {
    return this.forecastIntervalPrecipitation;
  } else if (this.typeSelected === this.TYPES.DIRECTION) {
    return this.forecastIntervalWindMAX;
  }
}
async getRangeForecastTemperature() {
  const max = (() => 32)();
  const min = (() => -32)();
  const r = max - min;
  const step = r / 72;
  const arr = [];
  for (let i = 0; i <= 72; i++) { arr.push(min + step * (i)); }
  this.intervalsForecastTemperature = [];
  arr.push(60);
  arr.unshift(-60);
  this.intervalsForecastTemperature = arr;
  return 123;
}
  async getRangeForecastPrecipitation() {
    const max = (() => 12.5)();
    const min = (() => 0.025)();
    const r = max - min;
    const step = r / 49;
    const arr = [];
    for (let i = 0; i <= 49; i++) { arr.push(min + step * (i)); }
    this.intervalsForecastPrecipitation = [];
    arr.push(60);
    this.intervalsForecastPrecipitation = arr;
    return 123;
  }
async forecastPlay() {
  let start;
  if (this.forecastHourIndex == 0) {
    start = 0;
  } else if (this.forecastHourIndex == this.forecastTimeline.length - 1) {
    start = this.forecastLastHiddenIndex + 1;
  } else {
    start = this.forecastHourIndex + 1;
  }
  const finish = this.forecastTimeline.length;
  this.forecastPlaying = true;
  for (let i = start; i < finish; i++) {
    this.forecastPlaying && (await (async () => {
      return await new Promise((resolve, reject) => {
        if (this.typeSelected === this.TYPES.DIRECTION){
          this.forecastPlayTimer = setTimeout(() => {
            this.setForecastHour(i);
            resolve(true);
          }, 2500);
        } else {
          this.forecastPlayTimer = setTimeout(() => {
            this.setForecastHour(i);
            resolve(true);
          }, 1500);
        }
      });
    })().then(async v => await v)) || (i = finish); // skip loop
  }
  this.forecastPlaying = false;
}
forecastStop() {
  this.forecastPlaying = false;
  clearTimeout(this.forecastPlayTimer);
}
getForecast() {
  if (this.typeSelected && this.typeSelected === this.TYPES.DIRECTION) {
    this.blurableSVG = false;
    this.blurableCANVAS = true;
    this.getForecastDirection();
    this.maxZoom = 17;
  }  else if (this.typeSelected && this.typeSelected === this.TYPES.TEMPERATURE) {
    this.blurableSVG = false;
    this.blurableCANVAS = false;
    this.maxZoom = 11;
    this.getForecastGeoTIFF();
  } else if (this.typeSelected && this.typeSelected === this.TYPES.PRECIPITATION) {
    this.blurableSVG = true;
    this.blurableCANVAS = false;
    this.maxZoom = 11;
    this.getForecastGeoTIFFPrecipitation();
  }
}
getForecastDate(type?) {
  this.canIuseGetForecastDate = false;
  setTimeout(() => this.canIuseGetForecastDate = true, 900);
  if (type && type !== this.typeSelected) {
    this.typeSelected = type;
    if (this.currentDate && this.currentHalfDay) {
      (async () => {
        function getLastHour(h) {
          if (h >= 21) { return 21; }
          if (h >= 18) { return 18; }
          if (h >= 15) { return 15; }
          if (h >= 12) { return 12; }
          if (h >= 9) { return 9; }
          if (h >= 6) { return 6; }
          if (h >= 3) { return 3; }
          if (h >= 0) { return 0; }
        }
        this.forecastTime = getLastHour((new Date()).getUTCHours());
        if (this.typeSelected === this.TYPES.TEMPERATURE) {
          const tmp2 = await this.getRangeForecastTemperature();
          const tmp5 = await this.getForecastGradientTemperature();
        } else if (this.typeSelected === this.TYPES.PRECIPITATION) {
          const tmp2 = await this.getRangeForecastPrecipitation();
          const tmp5 = await this.getForecastGradientPrecipitation();
        }

        const tmp3 = await this.getDays();
        this.getForecast();
      })();
    } else {
      if (this.subscribtionDate) { this.subscribtionDate.unsubscribe(); }
      this.subscribtionDate = this._maps.getDate().subscribe(
        async res => {
          const tmp = Object.keys(res);
          this.currentDate = tmp[tmp.length - 1];
          this.currentHalfDay = res[this.currentDate][res[this.currentDate].length - 1];

          const dir = Object.keys(res);
          this.forecastDate = dir[dir.length - 1];
          this.forecastTime = res[this.forecastDate][res[this.forecastDate].length - 1];
          function getLastHour(h) {
            if (h >= 21) { return 21; }
            if (h >= 18) { return 18; }
            if (h >= 15) { return 15; }
            if (h >= 12) { return 12; }
            if (h >= 9) { return 9; }
            if (h >= 6) { return 6; }
            if (h >= 3) { return 3; }
            if (h >= 0) { return 0; }
          }

          this.forecastTime = getLastHour((new Date()).getHours());
          if (this.typeSelected === this.TYPES.TEMPERATURE) {
            const tmp2 = await this.getRangeForecastTemperature();
            const tmp5 = await this.getForecastGradientTemperature();
          } else if (this.typeSelected === this.TYPES.PRECIPITATION) {
            const tmp2 = await this.getRangeForecastPrecipitation();
            const tmp5 = await this.getForecastGradientPrecipitation();
          }
          const tmp3 = await this.getDays();

          this.getForecast();
        }
      );
    }
  }
}
// direction
async getForecastDirection() {
  this.canLoadNext = false;
  this.minLoadInterval();

  this.forecastLayer && this.map.removeLayer(this.forecastLayer);
  this.loading = true;
  this.map.closePopup(); // close all popup
  const t1 = performance.now();
  const type = this.TYPES_MAP_selected;
  const hour = this.forecastTimeline[this.forecastHourIndex];
  const level = this.typesDIRECTIONSelected === '10M' ? 'single-level' : 'pressure-level';
  await this.unsubscribeGeotiff();

  this.subscribtionDirectionU = this._maps.getGeotiff(
    `forecast/${this.currentDate}/${this.currentHalfDay}/${hour}/${type.toLowerCase()}-eu_europe_regular-lat-lon_${level}_${this.currentDate}${this.currentHalfDay}_${hour}_${this.typesDIRECTIONSelected === '10M' ? 'U_10M' : this.typesDIRECTIONSelected + '_U'}.tiff`
  ).subscribe(
    async resU => {
      this.subscribtionDirectionV = this._maps.getGeotiff(
        `forecast/${this.currentDate}/${this.currentHalfDay}/${hour}/${type.toLowerCase()}-eu_europe_regular-lat-lon_${level}_${this.currentDate}${this.currentHalfDay}_${hour}_${this.typesDIRECTIONSelected === '10M' ? 'V_10M' : this.typesDIRECTIONSelected + '_V'}.tiff`
      ).subscribe(
        async resV => {
          const vf = L.VectorField.fromGeoTIFFs(resU, resV);
          // Слой Leaflet Velocity
          const velocityData = [{
            header: {
              parameterUnit: 'm/s',
              parameterNumber: 2,
              parameterNumberName: 'eastward_wind',
              parameterCategory: 2,
              nx: vf.nCols,
              ny: vf.nRows,
              lo1: vf.xllCorner,
              la1: vf.yurCorner,
              lo2: vf.xurCorner,
              la2: vf.yllCorner,
              dx: vf.cellXSize,
              dy: vf.cellYSize,
            },
            data: vf.us,
          },
            {
              header: {
                parameterUnit: 'm/s',
                parameterNumber: 3,
                parameterNumberName: 'V-component_of_wind',
                parameterCategory: 2,
                nx: vf.nCols,
                ny: vf.nRows,
                lo1: vf.xllCorner,
                la1: vf.yurCorner,
                lo2: vf.xurCorner,
                la2: vf.yllCorner,
                dx: vf.cellXSize,
                dy: vf.cellYSize,
              },
              data: vf.vs,
            }];
          this.forecastLayer && this.map.removeLayer(this.forecastLayer);
          // Добавление слоя Leaflet Velocity
          this.forecastLayer = L.velocityLayer({
            data: velocityData,
            displayValues: true,
            displayOptions: {
              velocityType: '',
              position: 'topleft',
              offset: [10, 10],
              emptyString: 'Для отображения данных кликните по карте',
              showCardinal: true,
              speedUnit: 'м/с', // Используем метры в секунду на русском
              directionUnit: '',
              directionString: 'Направление',
              speedString: 'Скорость',
            },
            maxVelocity: Math.ceil(vf.range[1]), // Максимальная скорость для отображения
            colorScale: ['#ffa41b', '#ff7f27', '#c4401e', '#880015', '#96255d', '#a349a4', '#522552', '#000000'],
            velocityScale: 1 / 75,
            particleMultiplier: 1 / 200
          });
          try {
            this.forecastLayer.addTo(this.map);
          } catch (error) {
            console.error('Ошибка при добавлении слоя на карту:', error);
          }

          const div = document.getElementsByClassName('leaflet-control-velocity') as HTMLCollectionOf<HTMLElement>;

          setTimeout(() => {
            const elem = div.item(0);
            elem.style.backgroundColor = '#FFFFFF';
            elem.style.padding = '3px';
            elem.style.borderRadius = '10px';
            elem.style.width = '60%';
            elem.style.textAlign = 'center';
            }, 0);

          // Логика клика на карту
          this.map.off('click');

          // Скролл к нужному индексу после получения данных
          this.moveScroll(this.forecastHourIndex);
          this.loading = false;
        }
      );
    }
  );
  this.canLoadNext = true;
}

// temperature
async getForecastGeoTIFF() {
  this.canLoadNext = false;
  this.minLoadInterval();
  this.loading = true;
  this.map.closePopup(); // close all popup
  const t1 = performance.now();

  await this.unsubscribeGeotiff();
  this.subscribtionTemperature = this._maps.getGeotiff(
    this.getGeoTiffFilename()
  ).subscribe(
    async res => {
      console.log('geoTIFF', res);

      const tiff = GeoTIFF.parse(res);
      const image = tiff.getImage();
      const tiffWidth = image.getWidth();
      const tiffHeight = image.getHeight();
      const rasters = image.readRasters();
      const tiepoint = image.getTiePoints()[0];
      const pixelScale = image.getFileDirectory().ModelPixelScale;
      const geoTransform = [tiepoint.x, pixelScale[0], 0, tiepoint.y, 0, -1 * pixelScale[1]];

      const uData = new Array(tiffHeight);
      const spdData = new Array(tiffHeight);
      for (let j = 0; j < tiffHeight; j++) {
        uData[j] = new Array(tiffWidth);
        spdData[j] = new Array(tiffWidth);
        for (let i = 0; i < tiffWidth; i++) {
          uData[j][i] = rasters[0][i + j * tiffWidth];
          spdData[j][i] = 1 * Math.sqrt(uData[j][i] * uData[j][i]);

        }
      }

      const intervals = this.intervalsForecastTemperature;
      const values = uData;
      const bandsWind = rastertools.isobands(values, geoTransform, intervals);

      const style = (feature) => {
        // console.log(feature)
        return {
          fillColor: this.getForecastColor('maybe type', feature.properties[0].upperValue),
          weight: 0,
          opacity: .7,
          color: this.getForecastColor('maybe type', feature.properties[0].upperValue),
          dashArray: '0',
          fillOpacity: 0.6
        };
      };

      this.scalarWindInterpolateLayer && this.map.removeLayer(this.scalarWindInterpolateLayer);
      this.forecastLayer && this.map.removeLayer(this.forecastLayer);
      this.forecastLayer = L.geoJson(bandsWind, {
        style
      });

      this.forecastLayer.addTo(this.map);

      this.loading = false;
      const t2 = performance.now();

      this.map.off('click');
      this.map.on('click', async (e: LeafletMouseEvent) => {
        const xTiff = (e.latlng.lng - geoTransform[0]) / geoTransform[1];
        const yTiff = (e.latlng.lat - geoTransform[3]) / geoTransform[5];
        const uValue = uData[Math.round(yTiff)][Math.round(xTiff)];
        const getValue = async () => {
          return await this._maps.getLatLng(
            e.latlng,
            this.getGeoTiffFilename().split('.')[0]
          ).then(
            async (res) => {
              // console.log(res);
              return await res;
            },
            err => 0
          );
        };
        const valueFromServer = await getValue();

        const content = () => {
          return `<div>${(Number.isFinite(uValue) ? `${Number(valueFromServer).toFixed(0)}` : '-none-')} °C</div>`;
        };

        const popup = L.popup({
          className: 'small-custom',
          closeButton: false,
          // autoClose: false,
          autoPan: false
        })
          .setLatLng(e.latlng)
          .setContent(content());
        if (Number.isFinite(uValue)) {
          popup.openOn(this.map);
        }
      });

      // Скролл к нужному индексу после получения данных
      this.moveScroll(this.forecastHourIndex);
    },
    err => {
      console.error('Forecast geoTIFF', err);
      this.loading = false;
    }
  );
  this.canLoadNext = true;
}

  async getForecastGeoTIFFPrecipitation() {
    this.canLoadNext = false;
    this.minLoadInterval();

    // var southWest = L.latLng(70, (-20)+360),
    // northEast = L.latLng(29, 45+360);
    // this.bounds = L.latLngBounds(southWest, northEast);
    // this.map.setMaxBounds(this.bounds);
    // this.map.on('drag', this.getBounds(this.bounds));

    // this.map.panTo(new L.LatLng(53.8, 380));
    this.loading = true;
    this.map.closePopup(); // close all popup
    const t1 = performance.now();
    // this.showingWindValues = false;
    // this.getForecastPower();
    // this.showForecastValues();
    // no date & tine - no geotiff because NEED FOR URL GEOTIFF

    if (this.forecastDate && Number.isFinite(this.forecastTime) && this.typeSelected) {
      await this.unsubscribeGeotiff();
      this.subscribtionPrecipitation = this._maps.getGeotiff(
        this.getGeoTiffFilename()
      ).subscribe(
        async res => {
          // console.log('geoTIFF', res);

          const tiff = GeoTIFF.parse(res);
          const image = tiff.getImage();
          const tiffWidth = image.getWidth();
          const tiffHeight = image.getHeight();
          const rasters = image.readRasters();
          const tiepoint = image.getTiePoints()[0];
          const pixelScale = image.getFileDirectory().ModelPixelScale;
          const geoTransform = [tiepoint.x, pixelScale[0], 0, tiepoint.y, 0, -1 * pixelScale[1]];

          const uData = new Array(tiffHeight);
          const spdData = new Array(tiffHeight);
          for (let j = 0; j < tiffHeight; j++) {
            uData[j] = new Array(tiffWidth);
            spdData[j] = new Array(tiffWidth);
            for (let i = 0; i < tiffWidth; i++) {
              uData[j][i] = rasters[0][i + j * tiffWidth];
              spdData[j][i] = 1 * Math.sqrt(uData[j][i] * uData[j][i]);

            }
          }

          // let a = await this.getRangeForecast(); <= RUN in getForecastDate()
          // await this.getForecastGradient(); <= RUN in getForecastDate()
          // let b = await this.getIntervalsForecast();
          // console.log('Worked');

          const intervals = this.intervalsForecastPrecipitation;
          const values = uData;
          const bandsWind = rastertools.isobands(values, geoTransform, intervals);

          const style = (feature) => {
            return {
              fillColor: this.getForecastColorPrecipitation('maybe type', feature.properties[0].upperValue),
              weight: 1,
              opacity: .7,
              color: this.getForecastColorPrecipitation('maybe type', feature.properties[0].upperValue),
              dashArray: '4',
              fillOpacity: .6
            };
          };

          this.scalarWindInterpolateLayer && this.map.removeLayer(this.scalarWindInterpolateLayer);
          this.forecastLayer && this.map.removeLayer(this.forecastLayer);
          this.forecastLayer = L.geoJson(bandsWind, {
            style
          });

          this.forecastLayer.addTo(this.map);


          // this.maskBelarus && this.map.removeLayer(this.maskBelarus);
          // this.maskBelarus.addTo(this.map);
          this.loading = false;
          const t2 = performance.now();
          // console.log("Call to doSomething took " + (t2 - t1) + " milliseconds.");

          this.map.off('click');
          this.map.on('click', async (e: LeafletMouseEvent) => {
            const xTiff = (e.latlng.lng - geoTransform[0]) / geoTransform[1];
            const yTiff = (e.latlng.lat - geoTransform[3]) / geoTransform[5];
            const uValue = uData[Math.round(yTiff)][Math.round(xTiff)];
            const getValue = async () => {
              return await this._maps.getLatLng(
                e.latlng,
                this.getGeoTiffFilename().split('.')[0]
              ).then(
                async (res) => {
                  // console.log(res);
                  return await res;
                },
                err => 0
              );
            };
            const valueFromServer = await getValue();

            const flooredUValue = Math.max(0, Number(uValue));

            const content = () => {
              return `<div>${Number(flooredUValue).toFixed(2)} мм</div>`;
            };

            const popup = L.popup({
              className: 'small-custom',
              closeButton: false,
              // autoClose: false,
              autoPan: false
            })
              .setLatLng(e.latlng)
              .setContent(content());
            if (Number.isFinite(flooredUValue)) {
              popup.openOn(this.map);
            }
          });
          // Скролл к нужному индексу после получения данных
          this.moveScroll(this.forecastHourIndex);
        },
        err => {
          console.error('Forecast geoTIFF', err);
          this.loading = false;
        }
      );
    }

    this.canLoadNext = true;
  }

  ngAfterViewInit() {
    this.subscribtionFooterHeight = this._shared.currentFooterHeight.subscribe(state => {
      this.isSmallScreen = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
      this.isMobileAds = this.breakpointObserver.isMatched('screen and (max-width: 788px)');
      this.isTabletAds = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');
      this.isSmallHeader = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
      if (!this.isMobileAds) {
        this.minZoom = 6;
      } else {
        this.minZoom = 5;
      }
    });
    this.getForecastDate(this.listTyped1[0].type);
    this.cdr.detectChanges();
    // Отключение всплытия нажатий по таймлайн панели (при варианте с click, события всплывали до первого нажатия)
    L.DomEvent.disableClickPropagation(this.controlContainer.nativeElement);
  }

  ngOnInit() {
    this._shared.currentCity.subscribe(city => {
      this.selectedCity = city;
    });
    this._shared.currentTime.subscribe(time => {
      this.timeUTC = time;
    });
  }

  unsubscribeGeotiff() {
    if (this.subscribtionDirectionU)    { this.subscribtionDirectionU.unsubscribe(); }
    if (this.subscribtionDirectionV)    { this.subscribtionDirectionV.unsubscribe(); }
    if (this.subscribtionTemperature)   { this.subscribtionTemperature.unsubscribe(); }
    if (this.subscribtionWindMAX)       { this.subscribtionWindMAX.unsubscribe(); }
    if (this.subscribtionPrecipitation) { this.subscribtionPrecipitation.unsubscribe(); }
    if (this.subscribtionCloudy)        { this.subscribtionCloudy.unsubscribe(); }
    if (this.subscribtionPMSL)          { this.subscribtionPMSL.unsubscribe(); }
    if (this.subscribtionRELHUM)        { this.subscribtionRELHUM.unsubscribe(); }
    if (this.subscribtionCAPE_CON)      { this.subscribtionCAPE_CON.unsubscribe(); }
  }
  ngOnDestroy() {
    if (this.subscribtionDate)          { this.subscribtionDate.unsubscribe(); }
    this.unsubscribeGeotiff();
    if (this.subscribtionFooterHeight)  { this.subscribtionFooterHeight.unsubscribe(); }
    if (this.subscribtionStorm)         { this.subscribtionStorm.unsubscribe(); }
    if (this.subscribtionHydroStorm)    { this.subscribtionHydroStorm.unsubscribe(); }
    if (this.subscribtionCity)          { this.subscribtionCity.unsubscribe(); }
    if (this.subscribtionTime)          { this.subscribtionTime.unsubscribe(); }
  }

}
